const navItems = [
  {
    id: 1,
    path: "/dashboard",
    title: "Dashboard",
    icon: "radix-icons:dashboard",
    active: true,
    roles: [
      "user",
      "technician",
      "supervisor",
      "manager",
      "destributor",
      "procurement",
      "admin",
      "owner",
      "agronomist",
    ],
  },
  {
    id: 2,
    path: "/farm",
    title: "Farm Overview",
    icon: "tdesign:location-1",
    active: true,
    roles: [
      "technician",
      "supervisor",
      "procurement",
      "manager",
      "admin",
      "owner",
    ],
  },
  {
    id: 3,
    path: "/inventory",
    title: "Inventory",
    icon: "ic:outline-inventory",
    active: true,
    roles: ["technician", "manager", "procurement", "admin", "owner"],
  },
  {
    id: 4,
    path: "/crops",
    title: "Crop Management",
    icon: "hugeicons:plant-02",
    active: true,
    roles: ["agronomist", "supervisor", "manager", "admin", "owner"],
  },
  {
    id: 5,
    path: "soil-fertilizer",
    title: "Soil & Fertilizer",
    icon: "iconoir:soil-alt",
    active: true,
    roles: ["agronomist", "supervisor", "manager", "admin", "owner"],
  },

  {
    id: 6,
    path: "/equipment",
    title: "Equipments",
    icon: "game-icons:farm-tractor",
    active: true,
    roles: [
      "technician",
      "supervisor",
      "manager",
      "procurement",
      "admin",
      "owner",
    ],
  },
  {
    id: 7,
    path: "/maintenance-logs",
    title: "Maintenance Logs",
    icon: "wpf:maintenance",
    active: true,
    roles: ["technician", "admin", "owner"],
  },
  {
    id: 8,
    path: "/supplies",
    title: "Supplies",
    icon: "carbon:scis-transparent-supply",
    active: true,
    roles: ["procurement", "admin", "owner"],
  },
  {
    id: 9,
    path: "/sales",
    active: true,
    title: "Sales",
    icon: "carbon:sales-ops",
    roles: [
      "procurement",
      "supervisor",
      "manager",
      "destributor",
      "admin",
      "owner",
    ],
  },
  {
    id: 10,
    path: "/tasks",
    title: "Task Management",
    icon: "fluent:tasks-app-28-regular",
    active: true,
    roles: [
      "user",
      "technician",
      "supervisor",
      "manager",
      "destributor",
      "procurement",
      "admin",
      "owner",
    ],
  },
  {
    id: 11,
    path: "/support",
    title: "Support",
    icon: "ix:support",
    active: true,
    roles: [
      "user",
      "technician",
      "supervisor",
      "manager",
      "destributor",
      "procurement",
      "admin",
      "owner",
    ],
  },
  {
    id: 12,
    path: "/settings",
    title: "Settings",
    icon: "mingcute:settings-3-line",
    active: true,
    roles: [
      "technician",
      "supervisor",
      "manager",
      "destributor",
      "procurement",
      "admin",
      "owner",
      "agronomist",
    ],
  },
];

export default navItems;
